
  import ipxRuntime$aVd11Q4IqFXuOOdIbQleF2N90Yk6qghg4SQSJkSf6YU from '/work/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536,
    "xs": 320,
    "xxl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "i.banks.kg",
    "staging.banks.kg"
  ],
  "alias": {},
  "densities": [
    1,
    2,
    1,
    2
  ],
  "format": [
    "avif",
    "webp",
    "webp"
  ],
  "quality": 75
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['ipx']: { setup: ipxRuntime$aVd11Q4IqFXuOOdIbQleF2N90Yk6qghg4SQSJkSf6YU, defaults: {"modifiers":{"quality":75,"format":"avif"},"http":{"maxAge":2592000,"ignoreCacheControl":true}} }
    }
  }
